import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DistrictWriteRequest } from '~/apis/ssf';
import { SSF } from '~/apis/api';
import { keys } from './queries';

export function useCreateDistrictMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.districtsCreate,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}

export function useUpdateDistrictMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: DistrictWriteRequest }) =>
      SSF.api.districtsPartialUpdate(id, payload),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.all }),
  });
}

export function useDeleteDistrictMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.districtsDestroy,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}
